import { create } from 'zustand';
import { subscribeAuthIdentity } from './auth.store';

export type SecurityChange = 'password_changed' | 'two_factor_enabled' | 'two_factor_disabled' | 'all_sessions_revoked' | 'current_session_revoked';

/** One-time response data must survive account-screen unmount, but never a reload
 * or identity switch. No persist middleware, URL, query cache or browser storage. */
export const useSecurityHandoff = create<{
  change: SecurityChange | null;
  backupCodes: string[] | null;
  prepare: (change: SecurityChange, backupCodes?: string[]) => void;
  acknowledgeCodes: () => void;
  clear: () => void;
}>((set) => ({
  change: null,
  backupCodes: null,
  prepare: (change, backupCodes) => set((state) => ({ change, backupCodes: backupCodes ?? state.backupCodes })),
  acknowledgeCodes: () => set({ backupCodes: null }),
  clear: () => set({ change: null, backupCodes: null }),
}));

subscribeAuthIdentity(() => useSecurityHandoff.getState().clear());

// The sign-in copy for each change lives with the login page
// (`pages/login/security-signin-handoff.tsx`, localized).
